import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'

import { TravelExpensesCommentInput } from '../../../lib/types/models/travel-expenses/travel-expenses-comment'
import { BaseFormProps } from '../../../lib/types/utils'
import { getSubmitAction } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { FORM_MODE } from '../../../utils/constants/form.constants'
import DateChip from '../../elements/date-chip'
import { Form, FormControl, FormField, FormItem } from '../../elements/forms/form'
import ControlledInput from '../../elements/inputs/controlled-input'
import ValidationButtons from '../../elements/validation-buttons'
import { TRAVEL_EXPENSES_COMMENT_SCHEMA } from './utils'

const TravelExpensesCommentForm = ({
  defaultValues,
  ...validationButtonProps
}: BaseFormProps<TravelExpensesCommentInput, true>) => {
  const form = useForm<TravelExpensesCommentInput>({
    resolver: zodResolver(TRAVEL_EXPENSES_COMMENT_SCHEMA),
    defaultValues,
    mode: FORM_MODE
  })

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}
        className="px-4 flex flex-col gap-3"
      >
        <div className="pt-7">
          <DateChip date={defaultValues?.updatedAt ?? new Date()} label={'Date'} />
        </div>
        <FormField
          control={form.control}
          name="comment"
          render={({ field }) => (
            <FormItem className="w-full">
              <FormControl>
                <ControlledInput {...field} type="textarea" label="Votre commentaire..." />
              </FormControl>
            </FormItem>
          )}
        />
        <ValidationButtons {...validationButtonProps} hasBorderTop />
      </form>
    </Form>
  )
}

export default TravelExpensesCommentForm
